module.exports = __webpack_public_path__ + "static/media/img3.e8e0032f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/img3.jpeg
// module id = 718
// module chunks = 0